import { Hero } from "../components/Hero";
import { Generator } from "../components/Generator";
import { Pricing } from "../components/Pricing";
import { FAQ } from "../components/FAQ";

export default function Home({ premium }) {
  return (
    <main>
      <Hero />
      <Generator premium={premium} />
      <Pricing premium={premium} />
      <FAQ />
    </main>
  );
}
